import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const priceAdjustmentSchema = new schema.Entity('priceAdjustment');

export const priceAdjustment = configureApiEntity('PRICEADJUSTMENTS', 'priceadjustments', priceAdjustmentSchema);
